export default __webpack_public_path__ + "static/media/LubeoilImg.50a8bfd0.svg";